import { graphql } from 'react-relay';

export const vocabularyListQuery = graphql`
	query vocabularyPage_list_Query {
		viewer {
			...vocabularyList_viewer
		}
	}
`;

export const vocabularyEditQuery = graphql`
	query vocabularyPage_edit_Query($id: ID!) {
		viewer {
			...vocabularyEdit_viewer @arguments(id: $id)
		}
	}
`;



// WEBPACK FOOTER //
// src/components/vocabulary/vocabulary-page.queries.js